import { Link } from "react-router-dom"
import { EmptyState } from "@/components/Feedback"

export function NotFoundPage() {
  return (
    <div className="page">
      <EmptyState
        icon="alert"
        title="Page not found"
        description="That route does not exist in this client."
        action={
          <Link to="/" className="btn btn-primary">
            Back home
          </Link>
        }
      />
    </div>
  )
}
